export const formatDateForInput = (value: any) => {
  if (!value) {
    return;
  }
  const timeStamp: number = Number(value);
  const dash = "-";
  const year = "" + new Date(timeStamp).getFullYear();
  const month =
    new Date(timeStamp).getMonth() + 1 <= 9
      ? "0" + (new Date(timeStamp).getMonth() + 1)
      : new Date(timeStamp).getMonth() + 1;
  const day =
    new Date(timeStamp).getDate() <= 9
      ? "0" + new Date(timeStamp).getDate()
      : new Date(timeStamp).getDate();

  return year + dash + month + dash + day;
};

export const generateTimeStamp = (date: string) => {
  const year = date.split("-")[0];
  const month = date.split("-")[1];
  const day = date.split("-")[2];

  return new Date(`${month} ${day} ${year}`).getTime();
};

export const getCorrectTaskInputType = (key: string): string => {
  if (!key) {
    return "";
  }
  let returnType: string = "";
  switch (key) {
    case "@fixed_expire":
    case "@fixed_last_access_date":
    case "@fixed_last_pwd_change":
    case "@fixed_last_wrong_login":
      returnType = "date";
      break;
    case "@fixed_number_login_error":
    case "@fixed_isDefault":
      returnType = "number";
      break;
    default:
      returnType = "text";
  }
  return returnType;
};

export const isDateTaskInputValue = (key: string): boolean => {
  if (!key) {
    return false;
  }
  if (
    key === "@fixed_expire" ||
    key === "@fixed_last_access_date" ||
    key === "@fixed_last_pwd_change" ||
    key === "@fixed_last_wrong_login"
  ) {
    return true;
  } else {
    return false;
  }
};
